import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PickImage, UploadImage } from '../../components/common/Camera';
import { InstallationAction, ErrorCodeAction, ProductAction } from '../../actions';
import { FileUpload, FileItem } from '../../components/common/FileUpload';
import { useTranslation } from 'react-i18next';
import { Translate as t } from '../../config/Translate';

const InstallationStep5 = ({ info, Update, isSummary = false, Attachment, gostep }) => {
	// const [ t, i18n ] = useTranslation();
	const [installation, setInstallation] = useState(info);
	const [docs, setDocs] = useState(installation.docs || []);
	// BUG-236: 첨부가 없는 설치건은 attachments 가 undefined 라 filter/map 에서 크래시(흰 화면)
	const attachments = installation?.attachments ?? [];

	useEffect(() => {
		setInstallation(info);
	}, [info]);

	// 현재 입력(docs)과 목표 단계를 함께 저장. '다음'·'이전'·상단 이동이 같이 쓴다.
	const saveStep = (targetStep) => {
		Update(installation._id, {
			installationStep: targetStep,
			docs: docs
		});
	};

	const Prev = () => {
		saveStep(5);
	};

	const validNext = (targetStep = 7) => saveStep(targetStep);

	// 상단 배지·◀▶ 이동: 이 단계는 검증이 없고 문서는 올리는 즉시 저장되므로 목표 단계와 docs 를 저장한다.
	useEffect(() => {
		if (gostep && gostep.curStep == 6) {
			validNext(gostep.goStepNo);
		}
	}, [gostep]);

	const setNewFile = (file, fileType) => {
		Attachment(installation._id, "ADD", {
			...installation,
			name: file.original,
			path: file.s3path,
			attachmentType: fileType
		});
	};

	const delFile = (c) => {
		Attachment(installation._id, "DEL", {
			...installation,
			delAttachid: c._id
		});
	};

	return (
		<>
			<div className="section">
				{!isSummary &&
					<>
						<div className="section-title">{t('installation.label.regulatoryDocument')}</div>
						<blockquote className="blockquote">
							<p class="mb-0">{t('installation.message.regulatoryDocumentComment')}</p>
						</blockquote>
						<div className="mb-2">
							<FileUpload
								option={{ doneandnew: true, label: t('common.button.upload') }}
								extraData={{ path: "installation/" + installation._id + "/" }}
								callback={(e) => setNewFile(e, 'doc')} />
						</div>
					</>
				}
				<ul className="list-group">
					{attachments.filter(item => 'doc' == item.type).length > 0 &&
						<>
							{attachments.map((c, idx) =>
								c.type == "doc" &&
								<li className="list-group-item ps-1" key={c._id}>
									<FileItem fileInfo={{ ...c, original: c.name, s3path: c.path }} callback={(c) => delFile(c)} key={idx} />
								</li>
							)}
						</>
					}
				</ul>
				{(isSummary && attachments.filter(item => 'doc' == item.type).length === 0) &&
					<div className="mb-2">
						<i>No Document</i>
					</div>}
			</div>
			{!isSummary && <div className="section mt-1 mb-2">
				<button className="btn btn-primary btn-block btn-lg" onClick={() => validNext()}>{t('common.button.next')}</button>
				<button className="btn btn-dark btn-block btn-lg mt-1" onClick={() => Prev()}>{t('common.button.back')}</button>
			</div>}
		</>
	);
};

const mapDispatch = (dispatch) => ({
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
	Attachment: (_id, type, data) => dispatch(InstallationAction.Attachment(_id, type, data)),
});

export default connect(null, mapDispatch)(InstallationStep5);